import { createContext, useContext, useEffect, useMemo, useState } from "react";
import fr from "./fr";
import en from "./en";
import es from "./es";
import pt from "./pt";
import { catalogTranslations } from "./catalog";
import { adminTranslations } from "./admin";

export const LANGS = ["fr", "en", "es", "pt"];
const DICTS = {
  fr: { ...fr, catalog: catalogTranslations.fr, admin: adminTranslations.fr },
  en: { ...en, catalog: catalogTranslations.en, admin: adminTranslations.en },
  es: { ...es, catalog: catalogTranslations.es, admin: adminTranslations.es },
  pt: { ...pt, catalog: catalogTranslations.pt, admin: adminTranslations.pt },
};
const LOCALES = { fr: "fr-FR", en: "en-GB", es: "es-ES", pt: "pt-PT" };
const Ctx = createContext(null);

const initialLang = () => {
  const q = new URLSearchParams(window.location.search).get("lang");
  if (LANGS.includes(q)) return q;
  const s = localStorage.getItem("mb300_lang");
  return LANGS.includes(s) ? s : "fr";
};

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(initialLang);

  useEffect(() => {
    localStorage.setItem("mb300_lang", lang);
    document.documentElement.lang = lang;
    document.title = DICTS[lang].meta.title;
    const m = document.querySelector('meta[name="description"]');
    if (m) m.setAttribute("content", DICTS[lang].meta.desc);
  }, [lang]);

  const value = useMemo(() => {
    const locale = LOCALES[lang];
    const eur = (n) =>
      new Intl.NumberFormat(locale, { style: "currency", currency: "EUR", maximumFractionDigits: 0, useGrouping: "always" }).format(n);
    return { lang, setLang, t: DICTS[lang], eur, locale };
  }, [lang]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useI18n = () => useContext(Ctx);
